import React from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';
import { withPrefix } from 'gatsby-link';

import Header from '../components/Header';
import Footer from '../components/Footer';
import ScrollTopButton from '../components/ScrollTopButton';

/* CSS */
import '../static/css/reset.css';
import '../static/css/superfish.css';
import '../static/css/jquery.qtip.css';
import '../static/css/style.css';
import '../static/css/animations.css';
import '../static/css/responsive.css';
import '../static/css/odometer-theme-default.css';

/* FONTS */
import '../static/fonts/streamline-small/style.css';
import '../static/fonts/template/styles.css';
import '../static/fonts/social/styles.css';

const Layout = ({ children, location, data }) => {
  const isKontakt = location.pathname === '/kontakt';
  console.log(isKontakt, location.pathname);

  return (
    <div style={{ position: 'relative' }} className="site-container">
      <Helmet
        title={data.site.siteMetadata.title}
        meta={[
          { charset: 'UTF-8' },
          {
            name: 'description',
            content: 'LUK & LUK Auto Serwis to Niezależny Serwis BMW. Jego siedziba znajduje się w Raciborzu, województwie śląskim od 2003 roku. Jako niezależny serwis BMW świadczymy bardzo szeroki zakres usług. Począwszy od okresowych przeglądów, wymiany opon i mechaniki, po kodowanie, zaawansowaną diagnostykę i naprawy powypadkowe.',
          },
          {
            name: 'viewport',
            content: 'width=device-width, initial-scale=1, maximum-scale=1.2',
          },
          {
            name: 'format-detection',
            content: 'telephone=no',
          },
        ]}
      />
      <Header siteTitle={data.site.siteMetadata.title} />
      <div>{children()}</div>
      <Footer showContact={isKontakt} />
      <ScrollTopButton />
    </div>
  );
};

Layout.propTypes = {
  children: PropTypes.func.isRequired,
  data: PropTypes.shape({}).isRequired,
};

export default Layout;

export const query = graphql`
  query SiteTitleQuery {
    site {
      siteMetadata {
        title
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/layouts/index.js